// Brillenhaus – findet die anderen Farben desselben Modells über die Modellnummer im Produkttitel
// (z. B. "0RB4171", "UN767-03" → "UN767", "RBSP-003-61" → "RBSP-003") und zeigt sie als Bild-Kacheln.
const TYPE_WORDS = ['magnet clip', 'magnetclip', 'sonnenbrille', 'skibrille', 'brillenfassung', 'brille', 'clip'];

const esc = (value) => String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

function typeWord(title) {
  const t = title.toLowerCase();
  return TYPE_WORDS.find((word) => t.includes(word)) || '';
}

function modelKey(title) {
  const tokens = title.split(/\s+/).map((t) => t.replace(/[(),]/g, ''));
  // Mengenangaben (360ml, 6er, 30Stk …) sind keine Modellnummern
  const isAmount = (t) => /^\d+([.,]\d+)?(ml|l|er|stk|stück|g|mm|%)$/i.test(t);
  const coded = tokens.find((t) => /\d/.test(t) && !isAmount(t) && t.replace(/\D/g, '').length >= 3 && t.length >= 4);
  if (coded) {
    const parts = coded.split('-');
    if (parts.length > 1 && parts.slice(0, -1).join('-').length >= 3) return parts.slice(0, -1).join('-');
    return coded;
  }
  // Ohne Nummer: Modellname nach dem Produkttyp (z. B. "Rolf Brillenfassung Tana L02")
  const lower = tokens.map((t) => t.toLowerCase());
  const idx = lower.findIndex((t) => TYPE_WORDS.includes(t));
  return idx >= 0 && tokens[idx + 1] && tokens[idx + 1].length >= 3 ? tokens[idx + 1] : '';
}

function colorLabel(title, key) {
  const i = title.indexOf(key);
  if (i < 0) return title;
  return title.slice(i + key.length).replace(/^[-\s\d/A-Z]*?(?=\s[a-zäöü])/, '').trim() || title;
}

async function init(root) {
  if (root.dataset.colorsReady) return;
  root.dataset.colorsReady = 'true';
  const { title, vendor, handle, image, heading } = root.dataset;
  const max = Number(root.dataset.max) || 8;
  const type = typeWord(title);
  // Nur bei Brillen, Sonnenbrillen und Clips – nicht bei Linsen oder Pflege
  if (!type) return;
  const key = modelKey(title);
  if (!key) return;

  let products = [];
  try {
    const url = `/search/suggest.json?q=${encodeURIComponent(key)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
    const data = await fetch(url).then((r) => r.json());
    products = data?.resources?.results?.products || [];
  } catch {
    return;
  }

  const siblings = products.filter(
    (p) =>
      p.handle !== handle &&
      p.title.includes(key) &&
      (!vendor || p.vendor === vendor) &&
      typeWord(p.title) === type &&
      p.featured_image?.url
  );
  if (!siblings.length) return;

  const items = [{ title, handle, img: image, current: true }]
    .concat(siblings.map((p) => ({ title: p.title, handle: p.handle, img: `${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=160` })))
    .slice(0, max);

  root.innerHTML = `
    <div class="bh-colors__head"><strong>${esc(heading)}</strong><span class="bh-colors__current">${esc(colorLabel(title, key))}</span></div>
    <ul class="bh-colors__list">
      ${items
        .map(
          (item) => `<li class="bh-colors__item${item.current ? ' is-current' : ''}">
            <a href="/products/${encodeURIComponent(item.handle)}" title="${esc(colorLabel(item.title, key))}" aria-label="${esc(item.title)}"${item.current ? ' aria-current="true"' : ''}>
              <img src="${esc(item.img)}" alt="" loading="lazy" width="64" height="48">
            </a></li>`
        )
        .join('')}
    </ul>`;
  root.hidden = false;
}

document.querySelectorAll('.bh-colors').forEach(init);
